import { Nav, Typography, Button, Space } from '@douyinfe/semi-ui';
import { IconTag } from '@douyinfe/semi-icons-lab';
import {
  IconGithubLogo,
  IconMoon,
  IconSun,
  IconShoppingBag,
  IconExternalOpen
} from '@douyinfe/semi-icons';
import { useSetTheme, useTheme } from '../context/Theme';

// 菜单按钮配置，方便后续添加更多按钮
const menuButtons = [
  {
    id: 'buy-token',
    name: '购买OpenAI Hub令牌',
    icon: <IconShoppingBag />,
    url: 'https://aigc.9b7.cn/shop/40.html',
    type: 'primary'
  },
  {
    id: 'chongzhi-token',
    name: 'OpenAI Hub令牌额度充值',
    icon: <IconShoppingBag />,
    url: 'https://aigc.9b7.cn/cpay/30.html',
    type: 'primary'
  }
  // {
  //   id: 'buy-token',
  //   name: '购买Sora2令牌',
  //   icon: <IconShoppingBag />,
  //   url: 'https://aigc.9b7.cn/shop/80.html',
  //   type: 'primary'
  // },
  // {
  //   id: 'chongzhi-token',
  //   name: 'Sora2令牌额度充值',
  //   icon: <IconShoppingBag />,
  //   url: 'https://aigc.9b7.cn/cpay/79.html',
  //   type: 'primary'
  // }
  // 后续可以在这里添加更多按钮
  // 格式为: { id: '唯一ID', name: '按钮名称', icon: <图标组件 />, url: '链接地址', type: '按钮类型' }
];

const HeaderBar = () => {
  const theme = useTheme();
  const setTheme = useSetTheme();

  // 处理按钮点击事件
  const handleButtonClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Nav
        mode='horizontal'
        header={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div 
              style={{ 
                display: 'flex', 
                alignItems: 'center',
                marginRight: '20px'
              }}
            >
              <IconTag size='large' style={{ marginRight: '8px' }} />
              <Typography.Title heading={5} style={{ margin: 0 }}>
                令牌查询---AIGC工具站[仅支持AIGC工具站所购令牌的查询]
              </Typography.Title>
            </div>
            
            <Space spacing="medium">
              {menuButtons.map(button => (
                <Button
                  key={button.id}
                  type={button.type || 'primary'}
                  icon={button.icon}
                  onClick={() => handleButtonClick(button.url)}
                  size="small"
                >
                  {button.name}
                </Button>
              ))}
            </Space>
          </div>
        }
        footer={
          <>
            {theme === 'dark' ? (
              <IconSun
                size="large"
                style={{ cursor: 'pointer', marginRight: '10px', color: 'var(--semi-color-text-2)' }}
                onClick={() => setTheme(false)}
              />
            ) : (
              <IconMoon
                size="large"
                style={{ cursor: 'pointer', marginRight: '10px', color: 'var(--semi-color-text-2)' }}
                onClick={() => setTheme(true)}
              />
            )}
            {process.env.REACT_APP_SHOW_ICONGITHUB === "true" && (
              <IconGithubLogo
                size="large"
                style={{ cursor: 'pointer', marginRight: '10px', color: 'var(--semi-color-text-2)' }}
                onClick={() => window.open('https://github.com/Calcium-Ion/neko-api-key-tool', '_blank')}
              />
            )}
          </>
        }
      />
    </div>
  );
};

export default HeaderBar;
